import { useState, useEffect } from 'react';
import isUrl from 'is-url';

import { useConfig } from 'Context/ConfigContext';

const useGoToBrowse = () => {
  const [enableBrowseUrl, setEnableBrowseUrl] = useState(false);
  const { myCourses } = useConfig();
  const { browseCoursesUrl } = myCourses;

  useEffect(() => {
    if (isUrl(browseCoursesUrl)) {
      setEnableBrowseUrl(true);
    }
  }, []);

  return { enableBrowseUrl, browseCoursesUrl };
};

export default useGoToBrowse;
